(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.parentElement
      ? document.currentScript.parentElement
      : document;

    function init() {
      var nodes = document.querySelectorAll('[data-tb-countdown]');
      if (!nodes.length) return;
      nodes.forEach(function (node) { startCountdown(node); });
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function nextMidnight(now) {
      var next = new Date(now);
      next.setHours(24, 0, 0, 0);
      return next;
    }

    function startCountdown(node) {
      var hoursEl = node.querySelector('[data-tb-hours]');
      var minutesEl = node.querySelector('[data-tb-minutes]');
      var secondsEl = node.querySelector('[data-tb-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) return;

      var target = nextMidnight(new Date());

      function tick() {
        var now = new Date();
        if (now >= target) {
          target = nextMidnight(now);
        }
        var diff = Math.max(0, target - now);
        var totalSeconds = Math.floor(diff / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      if (node._tbInterval) clearInterval(node._tbInterval);
      node._tbInterval = setInterval(tick, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-loondie-pdp"] && !Shopify.designMode) return;
  try {
    
const tbOpenCartDrawer = () => {
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer?.open) {
    drawer.open();
    return;
  }

  const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
  if (trigger) trigger.click();
};

const tbRefreshCartDrawer = async () => {
  const response = await fetch(`${window.location.pathname}?sections=header`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Cart drawer refresh failed');

  const sections = await response.json();
  const headerHtml = sections.header;
  if (!headerHtml) return;

  const nextDocument = new DOMParser().parseFromString(headerHtml, 'text/html');
  const nextDrawer = nextDocument.querySelector('cart-drawer-component.cart-drawer');
  const currentDrawer = document.querySelector('cart-drawer-component.cart-drawer');
  if (!nextDrawer || !currentDrawer) return;

  const nextTrigger = nextDrawer.querySelector('[data-testid="cart-drawer-trigger"]');
  const currentTrigger = currentDrawer.querySelector('[data-testid="cart-drawer-trigger"]');
  const nextDialogInner = nextDrawer.querySelector('.cart-drawer__inner');
  const currentDialogInner = currentDrawer.querySelector('.cart-drawer__inner');
  const currentDialog = currentDrawer.querySelector('.cart-drawer__dialog');
  const nextDialog = nextDrawer.querySelector('.cart-drawer__dialog');

  if (nextTrigger && currentTrigger) currentTrigger.innerHTML = nextTrigger.innerHTML;
  if (nextDialogInner && currentDialogInner) currentDialogInner.innerHTML = nextDialogInner.innerHTML;
  if (currentDialog && nextDialog) {
    currentDialog.className = nextDialog.className;
    currentDialog.setAttribute('aria-labelledby', nextDialog.getAttribute('aria-labelledby') || 'cart-drawer-heading');
  }
};

const tbFetchCart = async () => {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart refresh failed');
  return response.json();
};

const tbSetActiveProductMedia = (root, imageUrl, mediaId) => {
  if (!root || !imageUrl) return;

  const hero = root.querySelector('.tb-upairy-main__hero');
  if (hero) hero.src = imageUrl;

  const allThumbs = root.querySelectorAll('[data-tb-slide]');
  allThumbs.forEach((item) => item.classList.remove('is-active'));

  let activeThumb = null;
  if (mediaId) activeThumb = root.querySelector(`[data-tb-media-id="${mediaId}"]`);
  if (!activeThumb) {
    activeThumb = Array.from(allThumbs).find((item) => item.dataset.tbSlide === imageUrl);
  }
  if (activeThumb) {
    activeThumb.classList.add('is-active');
    activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
  }

  const mobileSlides = Array.from(root.querySelectorAll('.tb-upairy-main__mobile-slide'));
  let targetSlide = null;
  if (activeThumb) {
    const index = Array.from(allThumbs).indexOf(activeThumb);
    targetSlide = mobileSlides[index];
  }
  if (!targetSlide) {
    targetSlide = mobileSlides.find((slide) => slide.querySelector('img')?.currentSrc === imageUrl || slide.querySelector('img')?.src === imageUrl);
  }
  if (targetSlide) targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
};

const tbInitStockLevel = () => {
  document.querySelectorAll('[data-tb-stock-level]').forEach((stockBlock) => {
    if (stockBlock.dataset.initialized === 'true') return;
    stockBlock.dataset.initialized = 'true';

    const stockElement = stockBlock.querySelector('[data-tb-stock-count]');
    const squaresContainer = stockBlock.querySelector('[data-tb-stock-squares]');
    if (!stockElement || !squaresContainer) return;

    const productHandle = stockBlock.dataset.productHandle || 'product';
    const stockKey = `tbStockCountV2_${productHandle}`;
    const stockFloorKey = `tbStockFloorV2_${productHandle}`;
    const expiryKey = `tbStockExpiryV2_${productHandle}`;
    const expiryTime = 24 * 60 * 60 * 1000;

    const getStoredStock = () => {
      const storedStock = localStorage.getItem(stockKey);
      const storedExpiry = Number(localStorage.getItem(expiryKey) || 0);
      if (storedStock && storedExpiry && Date.now() < storedExpiry) {
        return Number.parseInt(storedStock, 10);
      }
      return null;
    };

    const setStoredStock = (count) => {
      localStorage.setItem(stockKey, String(count));
      localStorage.setItem(expiryKey, String(Date.now() + expiryTime));
    };

    let stockCount = getStoredStock();
    if (!Number.isFinite(stockCount)) {
      stockCount = Math.floor(Math.random() * 13) + 72;
      setStoredStock(stockCount);
    }

    let stockFloor = Number.parseInt(localStorage.getItem(stockFloorKey) || '', 10);
    if (!Number.isFinite(stockFloor)) {
      stockFloor = Math.floor(Math.random() * 4) + 16;
      localStorage.setItem(stockFloorKey, String(stockFloor));
    }

    const renderStock = () => {
      stockElement.textContent = String(stockCount);
      squaresContainer.replaceChildren();

      for (let index = 0; index < 5; index += 1) {
        const square = document.createElement('span');
        square.className = `tb-upairy-main__stock-square${index === 0 ? ' is-filled' : ''}`;
        squaresContainer.append(square);
      }
    };

    const decreaseStock = () => {
      if (stockCount > stockFloor) {
        stockCount = Math.max(stockFloor, stockCount - (Math.floor(Math.random() * 2) + 1));
        setStoredStock(stockCount);
        renderStock();
        window.setTimeout(decreaseStock, Math.floor(Math.random() * 60001) + 60000);
      }
    };

    renderStock();
    window.setTimeout(decreaseStock, Math.floor(Math.random() * 60001) + 60000);
  });
};

document.addEventListener('click', (event) => {
  const scrollLink = event.target.closest('a[href="#tb-pdp-offer-anchor"], a[href^="#tb-pdp-product-form"]');
  if (scrollLink) {
    const target = document.getElementById('tb-pdp-offer-anchor');
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#tb-pdp-offer-anchor');
      } else {
        window.location.hash = 'tb-pdp-offer-anchor';
      }
    }
    return;
  }

  const thumbArrow = event.target.closest('[data-tb-thumb-prev], [data-tb-thumb-next]');
  if (thumbArrow) {
    const root = thumbArrow.closest('.tb-upairy-main');
    const thumbs = root?.querySelector('.tb-upairy-main__thumbs');
    if (!thumbs) return;

    const direction = thumbArrow.matches('[data-tb-thumb-prev]') ? -1 : 1;
    const firstThumb = thumbs.querySelector('[data-tb-slide]');
    const scrollAmount = firstThumb ? firstThumb.getBoundingClientRect().width + 6 : 60;
    thumbs.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    return;
  }

  const button = event.target.closest('[data-tb-slide]');
  if (!button) return;

  const root = button.closest('.tb-upairy-main');
  tbSetActiveProductMedia(root, button.dataset.tbSlide, button.dataset.tbMediaId);
});

document.addEventListener('change', (event) => {
  const input = event.target.closest('.tb-upairy-main__patterns input');
  if (!input) return;

  const root = input.closest('.tb-upairy-main');
  const hiddenVariantInput = root.querySelector('[data-tb-variant-id]');
  const selectedPattern = root.querySelector('[data-tb-selected-pattern]');

  if (hiddenVariantInput) hiddenVariantInput.value = input.value;
  if (selectedPattern) selectedPattern.textContent = input.dataset.tbVariantTitle || '';
  if (input.dataset.tbVariantImage) {
    tbSetActiveProductMedia(root, input.dataset.tbVariantImage, input.dataset.tbVariantMediaId);
  }

  root.querySelectorAll('.tb-upairy-main__patterns label').forEach((label) => label.classList.remove('is-active'));
  input.closest('label').classList.add('is-active');
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.tb-upairy-main__form');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('[name="add"]');
  const originalText = button?.textContent;

  if (button) {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';
  }

  let itemAdded = false;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });

    if (!response.ok) throw new Error('Add to cart failed');
    itemAdded = true;

    const cart = await tbFetchCart();
    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: { cart, data: cart, resource: cart },
    }));
    await tbRefreshCartDrawer();
    tbOpenCartDrawer();
    window.setTimeout(tbOpenCartDrawer, 50);
  } catch (error) {
    if (itemAdded) {
      tbOpenCartDrawer();
    } else {
      form.submit();
    }
  } finally {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (originalText) button.textContent = originalText;
    }
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tbInitStockLevel);
} else {
  tbInitStockLevel();
}

  } catch(e) { console.error(e); }
})();
})();
